import React from "react";
import { Box, Tooltip, Typography } from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { useTour } from "./TourProvider";

/**
 * "Help?" at the bottom of the menu: opens the help center (setup checklist
 * and how-tos). `compact` is the icon-only collapsed sidebar.
 */
const HelpRow: React.FC<{ compact?: boolean; color?: string; onOpen?: () => void }> = ({
  compact = false,
  color,
  onOpen,
}) => {
  const { openHelp } = useTour();
  const open = () => {
    onOpen?.();
    openHelp();
  };
  const row = (
    <Box
      role="button"
      tabIndex={0}
      data-tour="help-row"
      onClick={open}
      onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && open()}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: compact ? "center" : "flex-start",
        gap: 1.25,
        mx: 1.5,
        mb: 1,
        px: compact ? 0 : 1.5,
        py: 1,
        minHeight: 44,
        borderRadius: 2,
        cursor: "pointer",
        color: color ?? "text.secondary",
        "&:hover, &:focus-visible": { bgcolor: "action.hover" },
      }}
    >
      <HelpOutlineIcon fontSize="small" />
      {!compact && <Typography sx={{ fontSize: "0.9rem", fontWeight: 600 }}>Help?</Typography>}
    </Box>
  );
  return compact ? (
    <Tooltip title="Help" placement="right">
      {row}
    </Tooltip>
  ) : (
    row
  );
};

export default HelpRow;
